import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {AuthService} from './services/auth.service';
import {OauthModel} from './shared/oauth.model';


export function OAuthProviderFactory(authService: AuthService) {
  return () => authService.load();
}

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [{ provide: APP_INITIALIZER, useFactory: OAuthProviderFactory,
    deps: [AuthService], multi: true }, AuthService],
  declarations: []
})

export class AuthModule {
  static forRoot(oauth: OauthModel, deps?: Array<any>) {
    return {
      ngModule: AuthModule,
      providers: [ AuthService, {provide: 'config', useValue: {oauth, deps} }]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts